import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import {Box, Button} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import {DashboardStyles} from "../../styles/dashboard";
import BannerMobile from "../../assets/images/dashboard_banner_mobile.png"
import BannerDesktop from "../../assets/images/dashboard_banner_desktop.png"

const useStyles = makeStyles((theme) => {
    return {
        ...DashboardStyles(theme),
        banner: {
            // height: '180px',
            width: '100%',
            margin: 'auto'
        },
        bannerDesktop: {
            // height: '240px',
            width: '100%',
            margin: 'auto'
        }
    }
});

const Banner = (props) => {
    const classes = useStyles();
    const history = useHistory();
    const desktop = useMediaQuery('(min-width:800px)');

    return (
        <Box style={{position:'relative', width:'100%'}} >
            <img src={desktop ? BannerDesktop : BannerMobile} className={desktop ? classes.bannerDesktop : classes.banner} />
            <Button variant='contained' color='primary' size='medium' style={{position:'absolute', bottom: '20px', right: '15px'}}
                    onClick={() => history.push('/dashboard/promo')}
            >Learn More</Button>
        </Box>
    );
}

export default Banner;